import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api.js';
import { useEffect, useState, useContext, useRef } from "react"
import { AppContext } from '@utils/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';
import TaskMenuItem from './components/TaskMenuItem';
import eventBus from "@utils/eventBus";
import Utils from "@utils/utils";
import { IMAGE_TYPE } from "@utils/CONST"
import { workflowOfLoadTaskInfo } from "@utils/workflowOfBuildTaskV2"
import PSAIModal from "@PSAIComponents/PSAIModal";
import AllprojectModal from './components/AllprojectModal'
import { message, Button } from 'antd';
import Iconfont from '@utils/Iconfont';

const RightComp = (props) => {
    const location = useLocation()
    const { globalTaskReadFlag,
        setGlobalTaskReadFlag,
        setProSidebarValue,
        selectedTaskListId,
        setSelectedTaskListId,
        setAIEditTempProjectId,
        AIEditRecentTaskId,
        setAIEditRecentTaskId,
        setAIEditRecentStatus
    } = useContext(AppContext);
    const [module, setModule] = useState()
    const [recentId, setRecentId] = useState()
    const [list, setList] = useState([])
    const [openAllProject, setOpenAllProject] = useState(false)
    const pollingRef = useRef(null);
    const taskListInProgessingRef = useRef([])
    const rightCompRef = useRef(null);

    // 失败的任务弹窗提醒
    const checkAndNotifyFailedTask = (list) => {
        const taskList = list
        if (taskList) {
            for (let i = taskListInProgessingRef.current.length - 1; i >= 0; i--) {
                const taskId = taskListInProgessingRef.current[i]
                const task = taskList.find(item => item?.taskId == taskId)
                if (task) {
                    if (task.status == 'failed' || task.status == 'succeeded') {
                        taskListInProgessingRef.current.splice(i, 1)
                        if (task.status == 'failed') {
                            const error = Utils.parseErrorCode(task.errCode)
                            eventBus.emit('notification', '生成失败', error.message, 'error', error.code)
                        }
                    }
                }
            }
            const newTaskListInProgressing = taskList.filter(task => {
                return task.status != 'failed' &&
                    task.status != 'succeeded' &&
                    !taskListInProgessingRef.current.find(taskId => task.taskId == taskId)
            })
            taskListInProgessingRef.current = [
                ...taskListInProgessingRef.current,
                ...newTaskListInProgressing.map(task => task.taskId)
            ]
        }
    }

    const pathname = location.pathname
    const isCreativeToImagePage = pathname == '/home/homemain/creativeToImage'
    useEffect(() => {
        if (
            pathname == '/home/homemain/model' ||
            pathname == '/home/homemain/background' ||
            pathname == '/home/homemain/poseTryon' ||
            pathname == '/home/homemain/clothes' ||
            pathname == '/home/homemain/shoesTryon' ||
            pathname == '/home/homemain/glassesTryon' ||
            pathname == '/home/homemain/necklaceTryon' ||
            pathname == '/home/homemain/simTryon' ||
            pathname == '/home/homemain/flatlay3d' ||
            pathname == '/home/homemain/clothRecolor' ||
            pathname == '/home/homemain/fusionWear' ||
            pathname == '/home/homemain/grassPlant' ||
            pathname == '/home/homemain/smartDetailPage' ||
            pathname == '/home/homemain/watermarkRemove' ||
            pathname == '/home/homemain/commodity' ||
            pathname == '/home/homemain/commodityRecolor'
        ) {
            setModule('model')
        } else if (pathname == '/home/homemain/creativeToImage') {
            setModule('creativeImage')
        } else if (pathname == '/home/aiEdit') {
            setModule('aiEdit')
        } else if (pathname == '/home/homemain/model_video_img' || pathname == '/home/homemain/model_video') {
            setModule('modelVideo')
        } else {
            setModule('other')
        }
    }, [location.pathname])

    const listRecentProjectv2 = () => {
        commonApiInvoker(API.listRecentProjectv2({
            module: module
        })).then(res => {
            const hasProcessing = res.some(item =>
                item.status === 'processing' ||
                item.status === 'pending' ||
                item.status === 'started'
            );

            const targetItem = res.find(item => item.recentTaskId === AIEditRecentTaskId);
            const shouldSetTrue = targetItem && targetItem.status !== 'failed' && targetItem.status !== 'succeeded';
            setAIEditRecentStatus(shouldSetTrue);

            setList(res);

            if (hasProcessing) {
                if (pollingRef.current) {
                    clearTimeout(pollingRef.current);
                }
                pollingRef.current = setTimeout(() => {
                    listRecentProjectv2()
                }, 1000);
            } else {
                if (pollingRef.current) {
                    checkAndNotifyFailedTask(res)
                    clearTimeout(pollingRef.current)
                    pollingRef.current = null
                }
            }
        })
    }

    useEffect(() => {
        if (!module || !localStorage.getItem('token')) return
        listRecentProjectv2()

        return () => {
            if (pollingRef.current) {
                clearTimeout(pollingRef.current)
            }
        }
    }, [module, globalTaskReadFlag])

    // 重新编辑
    const navigate = useNavigate()
    const handleClick = async (item) => {
        if (recentId) return //避免重复点击
        if (module == 'aiEdit') {
            if (item.status == "failed") {
                message.error('任务失败，请选择其他结果！')
                return
            }
        }


        setRecentId(item.id)
        setSelectedTaskListId(item.id)

        // 取无抹除图，若未完成取输入图
        let recentResImage
        if (item.status == "succeeded") {
            const noWaterImage = await API.commonDownload({ taskId: item.recentTaskId })
            if (!noWaterImage) { setRecentId(); return }
            recentResImage = noWaterImage.data
        } else {
            recentResImage = item.mainImage
        }

        // 设置已读未读
        API.setProjectReadFlag({ projectId: item.id }).then(() => {
            setGlobalTaskReadFlag(prev => !prev)
        }).catch(() => {
            setRecentId();
        })

        // AI 编辑
        if (props.imageType == IMAGE_TYPE.AIEDIT) {
            setRecentId()
            setAIEditTempProjectId(item.id)
            setAIEditRecentTaskId(item.recentTaskId)
            if (item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION) {
                window.open(recentResImage ? `/home/image_extraction?url=${encodeURIComponent(recentResImage)}` : `/home/image_extraction`, '_blank')
            } else if (item.imageType == IMAGE_TYPE.REMOVE_INPAINT) {
                navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: recentResImage, status: item.status } })
            } else if (item.imageType == IMAGE_TYPE.AI_BEAUTY) {
                navigate("/home/aiEdit", { state: { menuKey: 'filllight', picUrl: recentResImage, status: item.status } })
            } else if (item.imageType == IMAGE_TYPE.IMAGE_FINER) {
                navigate("/home/aiEdit", { state: { menuKey: 'imageFiner', picUrl: recentResImage, status: item.status } })
            } else if (item.imageType == IMAGE_TYPE.IMAGE_OUTPAINTING) {
                navigate("/home/aiEdit", {
                    state: {
                        menuKey: 'outpaint',
                        picUrl: recentResImage,
                        projectId: item.id,
                        taskId: item.recentTaskId,
                        status: item.status
                    }
                })
            } else if (item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY) {
                navigate("/home/aiEdit", { state: { menuKey: 'beautify', picUrl: recentResImage, status: item.status } })
            } else if (item.imageType == IMAGE_TYPE.IMAGE_RESIZE) {
                navigate("/home/aiEdit", {
                    state: {
                        menuKey: 'imageResize',
                        picUrl: recentResImage,
                        projectId: item.id,
                        taskId: item.recentTaskId,
                        status: item.status
                    }
                })
            } else if (item.imageType == IMAGE_TYPE.HAND_FIX) {
                navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: recentResImage, status: item.status } })
            }
            return
        }

        const imageType = item.imageType
        const taskId = item.recentTaskId
        const res = await workflowOfLoadTaskInfo(imageType, taskId)
        if (!res) { setRecentId(); return }
        const { pathname, options } = res
        setRecentId()
        navigate(pathname, options)
    }

    const scrollRef = useRef(true)


    // 滚动到选中的任务项
    useEffect(() => {
        if (!scrollRef.current) return
        if (selectedTaskListId && rightCompRef.current) {
            setTimeout(() => {
                const selectedItem = document.getElementById(`task-item-${selectedTaskListId}`);
                if (selectedItem) {
                    selectedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    scrollRef.current = false
                }
            }, 0);
        }
    }, [selectedTaskListId, list]);

    const newTaskClick = () => {
        navigate(location.pathname, {
            state: {
                taskInfo: {
                    projectId: null,
                }
            }
        })
        setSelectedTaskListId(null);
        setAIEditTempProjectId(null);
        setRecentId(null);
        if (props.imageType == IMAGE_TYPE.AIEDIT) {
            sessionStorage.removeItem('imgResizeCache')
            setAIEditRecentTaskId(null)
            setAIEditRecentStatus(false)
            navigate("/home/aiEdit", { state: { menuKey: 'imageResize', picUrl: null, projectId: null, taskId: null } })
        }
    }

    return (
        <div
            className={`${styles.RightCompBox} ${isCreativeToImagePage ? styles.RightCompBoxCreativeImage : ''}`}
            ref={rightCompRef}
        >
            {
                list.length > 0 && <div className={`${styles.RightComp} ${isCreativeToImagePage ? styles.RightCompCreativeImage : ''}`}>
                    <div className={styles.newTaskBtn} onClick={newTaskClick}>
                        <Iconfont className={styles.Icon2} type="icon-newProjectOutlined" />
                        新项目
                    </div>
                    <div className={`${styles.RightCompWList} _beauty_scrollbar`}>
                        {
                            list?.map((item) => (
                                <TaskMenuItem
                                    item={item}
                                    selectedTaskListId={selectedTaskListId}
                                    recentId={recentId}
                                    key={item.id}
                                    onClick={handleClick} />
                            ))
                        }
                        {
                            list.length >= 19 &&
                            <p className={styles.allBtn}
                                onClick={() => {
                                    setProSidebarValue(module);
                                    navigate('/home/myProject/list')
                                }}
                            >
                                查看全部</p>
                        }
                    </div>
                </div>
            }

            <PSAIModal
                title="全部项目"
                open={openAllProject}
                maskClosable={false}
                footer={null}
                maxWidth={1070}
                onCancel={() => setOpenAllProject(false)}
                getContainer={"body"}
            >
                <AllprojectModal module={module} />
            </PSAIModal>
        </div>
    )
}

export default RightComp
